import { Activity, LayoutDashboard, Wallet, Timer, Gauge, Clock3, AlertTriangle, Award, Building2, HardHat, RefreshCw, UserCog, MessageCircle, Presentation, Settings, ThumbsDown, Upload } from "lucide-react";

export const MODULES = [
  { id: "ringkasan", label: "Ringkasan", icon: LayoutDashboard, path: "/" },
  { id: "live", label: "Bulan Berjalan", icon: Activity, path: "/live", custom: true },
  { id: "pendapatan", label: "Pendapatan", icon: Wallet, path: "/m/pendapatan" },
  { id: "sla", label: "SLA", icon: Timer, path: "/m/sla" },
  { id: "bpp", label: "BPP", icon: Gauge, path: "/m/bpp" },
  { id: "rpt_rct", label: "RPT-RCT", icon: Clock3, path: "/m/rpt_rct" },
  { id: "denda", label: "Denda", icon: AlertTriangle, path: "/m/denda" },
  { id: "reward", label: "Reward", icon: Award, path: "/m/reward" },
  { id: "aset", label: "Aset Pengusahaan", icon: Building2, path: "/m/aset" },
  { id: "produktivitas", label: "Produktivitas YO", icon: HardHat, path: "/m/produktivitas" },
  { id: "anomali", label: "Anomali WO", icon: ThumbsDown, path: "/m/anomali" },
];

export const ADMIN_NAV = [
  { id: "laporan", label: "Laporan PPT", icon: Presentation, path: "/laporan", roles: ["admin", "manajemen", "operasional", "viewer"] },
  { id: "sync", label: "Sinkronisasi", icon: RefreshCw, path: "/sync", roles: ["admin"] },
  { id: "upload", label: "Upload Data", icon: Upload, path: "/upload", roles: ["admin"] },
  { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, path: "/whatsapp", roles: ["admin", "manajemen"] },
  { id: "users", label: "Pengguna", icon: UserCog, path: "/users", roles: ["admin"] },
  { id: "settings", label: "Pengaturan", icon: Settings, path: "/settings", roles: ["admin"] },
];

export const MODULE_IDS = MODULES.filter((m) => !m.custom).map((m) => m.id);
